module.exports = __webpack_public_path__ + "img/do.051b5a5e.svg";